import React,{useState} from 'react'
import {
  Modal,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Row,
  FormGroup,
  Form,
  Button,
} from 'react-bootstrap'
///import * as Icon from 'react-feather'
import FeatherIcon from 'feather-icons-react'
export const PropertiesEditModal = ({show,onChange,onHide,item})=>{

  const [applyItem,setApplyItem] = useState(item)

  const onEdit = (citem,index)=>{

  }


  const updateData = (citem,index,text)=>{

      item.fieldVariable.props = item.fieldVariable.props?item.fieldVariable.props:{}
      item.fieldVariable.props[citem] = {'title':text}
      //onChange(item)
      setApplyItem({...item})

  }

  const onApply = ()=>{
    if(onChange){
      onChange(applyItem)
    }
    onHide()
  }


  const renderTable = ()=>{
    const noOfColumn = item.columns?item.columns.length:4
        return (
          <table   className="table-dynamic-report">
            <thead>
              <tr>
                {item.columns ? (
                  item.columns.map((citem,index)=>(
                    <td key={index}>
                    <Form.Control
                        autoComplete="off"
                        value={(item.fieldVariable.props && item.fieldVariable.props[citem])?item.fieldVariable.props[citem].title:citem}
                        onChange={(e) => updateData(citem,index, e.target.value)}
                      />
                    </td>
                  ))
                ):
                  new Array(noOfColumn).fill('').map((item,index)=>(
                  <td key={index}>Column{index}</td>
                ))}
              </tr>
            </thead>
            <tbody>
              {item.value && Array.isArray(item.value) ?(
                item.value.map((ritem,rindex)=>(
                  <tr key={rindex}>
                    {item.columns.map((citem,index)=>(
                      <td>{ritem[citem]}</td>
                    ))}
                  </tr>
                ))
              )
              :new Array(4).fill('').map((item,rindex)=>(
                <tr key={rindex}>
                  {new Array(noOfColumn).fill('').map((item,cindex)=>(
                    <td>{rindex} - {cindex}</td>
                  ))}
                </tr>  ))}
            </tbody>
          </table>
        )
  }


  return (
    <Modal show={show} dialogClassName="modal-100w" onHide={() => onHide()}>
        <Modal.Header className="bg-primary" closeButton>
            Table Style
        </Modal.Header>
        <Modal.Body row>
          <Row>
                  <Col md={12}>
                    {renderTable()}
                  </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer row>
            <Button onClick={()=>onApply()}><FeatherIcon
                      size="16"
                      icon="save"
                      className="vx-icon"            
                    /> Apply</Button>
        </Modal.Footer>
    </Modal>
  )
}
